import { render, staticRenderFns } from "./tag-group-delete-modal.vue?vue&type=template&id=534833ab&scoped=true&"
import script from "./tag-group-delete-modal.vue?vue&type=script&lang=js&"
export * from "./tag-group-delete-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-group-delete-modal.vue?vue&type=style&index=0&id=534833ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534833ab",
  null
  
)

export default component.exports